import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="global-footer" className="border-t border-[#15152a] mt-24">
    <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-[#00ff88] text-2xl">◈</span>
        <span className="font-semibold text-white">CHEATCRAFT</span>
        <span className="ml-3 cc-overline">© 2026 · CHEATCRAFT</span>
      </div>
      <div className="flex items-center gap-6 text-sm text-[#a0a0b0]">
        <Link to="/faq" data-testid="footer-faq-link" className="hover:text-white">FAQ</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms</Link>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy</Link>
        <a data-testid="footer-contact-link" href="mailto:support@cheatcraft.net" className="hover:text-white">Contact</a>
      </div>
    </div>
  </footer>
);

export default Footer;
